import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  numberPercent: {
    defaultMessage: '{number}<span>%</span>',
  },
});
